import { useCountdown } from 'src/hooks/useCountDown.hook'
import { useEffect } from 'react'
import { DateUtils } from 'src/utils/date'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { Roboto_num3_b14, Roboto_num4_b12 } from 'src/styles/fonts/RobotoFonts'
import styled from 'styled-components'
import { HotDealItemListsSpace } from 'src/types/api'
import { durationFadeTransitionProps } from 'src/styles/animation'
import { useModal } from 'src/provider/ModalContextProvider'
import usePageNav from 'src/hooks/usePageNav.hook'
import { queryClient } from 'src/router'
import usePathMatch from 'src/hooks/usePathMatch.hook'

const HotDealPreceed = ({
  EndDT,
  position,
  colorOption,
}: Pick<HotDealItemListsSpace.HotDealItemType, 'EndDT'> & {
  position?: { t?: string; r?: string; b?: string; l?: string }
  colorOption?: 'default' | 'black'
}) => {
  const { getDayDifference, expiration1Days, DateFormat } = DateUtils
  const { openModal } = useModal()
  const { mainPageNav } = usePageNav()
  const { match_main } = usePathMatch()

  const countExpiredCallbackFn = () => {
    queryClient.removeQueries({ queryKey: ['hot_deal_list'] })
    if (!match_main) {
      openModal({
        contents: { t: '핫딜 종료', d: '핫딜이 종료 되었습니다. \n 메인 화면으로 이동합니다.' },
        button: { submit: { t: '확인', f: mainPageNav } },
      })
    } else {
      window.location.reload()
    }
  }

  const { countStart, count } = useCountdown({ countExpiredCallbackFn })

  const itemsOfSellFlag = {
    date: expiration1Days(EndDT) ? DateFormat(EndDT?.replace(/-/g, '/'), 'YYYY/MM/DD') : EndDT,
    chipsText: '남은시간',
    dateDisplayText: `${expiration1Days(EndDT) ? `${getDayDifference(EndDT, 'days')}일` : `${count}`}`,
  }
  const { dateDisplayText, chipsText, date } = itemsOfSellFlag

  useEffect(() => {
    countStart(Number(getDayDifference(date, 'seconds')))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [EndDT])

  return (
    <S.ActionTimer.Container $option="flex_row" $position={position}>
      <S.ActionTimer.Contents $option="flex_row">
        <S.ActionTimer.StatusChips $colorOption={colorOption}>
          <S.ActionTimer.Status $fontStyle={Roboto_num4_b12} {...durationFadeTransitionProps}>
            {chipsText}
          </S.ActionTimer.Status>
        </S.ActionTimer.StatusChips>
        <S.ActionTimer.Time $option="flex_row" $column_gap="4px">
          <Typography $fontStyle={Roboto_num3_b14} $color="var(--black-60)">
            {dateDisplayText}
          </Typography>
        </S.ActionTimer.Time>
      </S.ActionTimer.Contents>
    </S.ActionTimer.Container>
  )
}
export default HotDealPreceed

const S = {
  ActionTimer: {
    Container: styled(Container)<{
      $position?: { t?: string; r?: string; b?: string; l?: string }
    }>`
      position: relative;
      height: 0;
      width: 100%;
      top: ${(props) => props.$position?.t || 'unset'};
      bottom: ${(props) => props.$position?.b || 'unset'};
      right: ${(props) => props.$position?.r || 'unset'};
      left: ${(props) => props.$position?.l || 'unset'};
    `,
    Contents: styled(Container)`
      justify-content: space-between;
      align-items: center;
      gap: 8px;
      border: 1px solid rgba(0, 0, 0, 0.08);
      width: fit-content;
      min-width: 138px;
      height: 25px;
      color: var(--white);
      border-radius: 100px;
      background: rgba(255, 255, 255, 0.95);
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    `,
    StatusChips: styled.section<{ $colorOption?: 'default' | 'black' }>`
      display: flex;
      background: ${({ $colorOption }) =>
        $colorOption === 'black' ? '#343434' : 'var(--brand-50)'};
      border-radius: 100px;
      min-width: 60px;
      width: 60px;
      justify-content: center;
    `,
    Time: styled(Container)`
      width: 100%;
      justify-content: center;
      align-items: center;
      padding-right: 8px;
    `,
    Status: styled(Typography)`
      display: flex;
      align-items: center;
      height: 26px;
    `,
  },
}
